import DepartmentList from "./DepartmentList";
import ParkList from "./ParkList";
import InvestorList from "./InvestorList";
import UserList from "./UserList";
import EthiopianRegions from "./EthiopianRegions";
import CountryList from "./CountryList";
import ParcelsInParkList from "./ParcelsInParkList";
//import Av from "./"
import ConsultantList from "./ConsultantList";
import ContractorList from "./ContractorList";
import AgreementList, {AgreementListInPark} from "./AgreementList";
import InvestorsInParkList from "./InvestorsInParkList";
export {
    ParkList,
    DepartmentList,
    InvestorList,
    UserList,
    EthiopianRegions,
    CountryList,
    ParcelsInParkList,
    ContractorList,
    ConsultantList,
    AgreementList,
    AgreementListInPark,
    InvestorsInParkList,
};